import { createElementBlock as c, openBlock as n, createElementVNode as e } from "vue";
const r = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-share-whatsapp"
};
function s(t, l) {
  return n(), c("svg", r, l[0] || (l[0] = [
    e("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: "#F2F2F2",
      class: "svg__fill--secondary-grey-01"
    }, null, -1),
    e("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.39524 16.1232c.00215-4.9567 4.03476-8.9877 8.99096-8.9877h.0004c2.4034.00112 4.6632.93809 6.3597 2.63606 1.6965 1.69804 2.6319 3.95844 2.631 6.35864v.0001c-.0022 4.9563-4.0347 8.9879-8.9907 8.9879h-.0038c-1.4028-.0004-2.783-.3288-4.0282-.9536l-4.08802 1.072-1.25681.3295.34322-1.2531 1.08861-3.9747c-.55727-1.05-.89919-2.1988-1.00815-3.3832l-.03857.0042.00036-.8361Zm1.50022-.0547-.00002.0552c-.00047 1.3205.34445 2.6084.99966 3.7435l.1565.2711-.08269.3019-.82599 3.0159 3.11188-.816.2878-.0755.2613.1424c1.0934.5959 2.3252.9108 3.5791.9112H16.3866c4.1276 0 7.4889-3.3602 7.4907-7.4886l.75.0004-.75-.0004c.0008-2.0023-.7767-3.8812-2.1921-5.2978l.527-.5266-.527.5266c-1.415-1.41623-3.2931-2.19527-5.299-2.1963m-7.49074 7.433c.03164-4.1031 3.38104-7.43281 7.49034-7.433Zm5.35904-3.6626c-.1598-.3552-.3279-.3623-.4799-.3686-.1244-.0053-.2667-.0049-.4088-.0049-.1423 0-.3733.0534-.5687.2668-.1956.2135-.7467.7295-.7467 1.7788 0 1.0495.7645 2.0636.871 2.206.1066.1422 1.4756 2.3647 3.6434 3.2196 1.8019.7105 2.1685.5692 2.5596.5336.3911-.0356 1.262-.5159 1.4397-1.0139.1778-.498.1778-.9249.1245-1.0141-.0533-.0889-.1956-.1423-.4089-.2489-.2134-.1066-1.262-.6227-1.4575-.6939-.1955-.0711-.3377-.1066-.48.107-.1422.2132-.5507.6935-.6752.8358-.1244.1425-.2489.1603-.4621.0537-.2134-.1071-.9004-.3321-1.7153-1.0586-.6341-.5654-1.0622-1.2636-1.1867-1.4771-.1244-.2133-.0133-.3289.0937-.4352.0958-.0956.2134-.2491.32-.3735.1065-.1246.142-.2135.2131-.3558.0711-.1423.0356-.2669-.0177-.3736-.0534-.1067-.4679-1.1615-.6576-1.5833",
      fill: "#0F0F0F",
      class: "svg__fill--black"
    }, null, -1)
  ]));
}
const i = { render: s };
export {
  i as default,
  s as render
};
